const API_URL = window.location.origin.toString() + '/api';

export default API_URL;